const OptInEnum = Object.freeze({
  OPT_IN: 'OPTIN',
  OPT_OUT: 'OPTOUT',
});

const UserActionEnum = Object.freeze({
  SMS_PAGE_OPEN: 0,
  SMS_ACCEPT_OPT_IN: 1,
  SMS_DECLINE_OPT_IN: 2,
});

const validSourceCarriers = Object.freeze(['nexmo', 'twilio']);

export {
  OptInEnum,
  UserActionEnum,
  validSourceCarriers,
};
